import moment from "moment";
import { Announcement } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class AnnouncementsAdapter {
  value: any;

  constructor(input: any) {
    this.value = input;
  }

  get created_at() {
    return moment(this.value.created_at).format("YYYY-MM-DD");
  }

  get updated_at() {
    return moment(this.value.updated_at).format("YYYY-MM-DD");
  }

  get visibility_start_date() {
    return moment(this.value.visibility_start_date).format("YYYY-MM-DD");
  }

  get visibility_end_date() {
    return moment(this.value.visibility_end_date).format("YYYY-MM-DD");
  }

  get image() {
    return this.value.image
      ? `${process.env.REACT_APP_API_ASSETS}${this.value.image.id}`
      : "https://placehold.co/400x400";
  }

  adapt(): Announcement {
    return {
      id: this.value.id,
      descripcion_breve: this.value.descripcion_breve,
      areas: this.value.areas,
      sub_areas: this.value.sub_areas,
      nombre: capitalizeString(this.value.nombre),
      created_at: this.value.created_at || "N/A",
      updated_at: this.value.updated_at || "N/A",
      descripcion_detallada: this.value.descripcion_detallada,
      expectativas_solucion: this.value.expectativas_solucion,
      presupuesto: this.value.presupuesto,
      requisitos_deseables: this.value.requisitos_deseables,
      requisitos_no_deseables: this.value.requisitos_no_deseables,
      requisitos_obligatorios: this.value.requisitos_obligatorios,
      solucion: this.value.solucion,
      tecnologias: this.value.tecnologias,
      tipo_organizacion: this.value.tipo_organizacion,
      user_created: this.value.user_created,
      user_updated: this.value.user_updated,
      visibility_end_date: this.visibility_end_date,
      visibility_start_date: this.visibility_end_date,
      image: this.image,
      url: this.value.url,
      status: this.value.status,
      document: this.value.document,
      institucion: this.value.institucion,
      responsable: this.value.responsable,
    };
  }
}
